import { docLinkPreviewInfoValidPeriod } from './constants';
import DocLinkPreviewInfo from '../store/schema/DocLinkPreviewInfo';
import getStore from '../store/store';

export default function getValidDocLinkPreviewInfo(url: string): DocLinkPreviewInfo | null {
    const { docLinkPreviewInfo } = getValidDocLinkPreviewInfoWithReason(url);
    return docLinkPreviewInfo || null;
}

export function getValidDocLinkPreviewInfoWithReason(url: string): DocLinkPreviewInfoWithReason {
    const docLinkPreviewInfo = getStore.docLinkPreviewInfoMap.get(url);
    if (!!docLinkPreviewInfo) {
        if (docLinkPreviewInfo.time + docLinkPreviewInfoValidPeriod > Date.now()) {
            return { docLinkPreviewInfo };
        } else {
            return { reason: 'Expired' };
        }
    }

    if (
        getStore.getWacInfoQueue.some(queued => queued === url) ||
        getStore.activeGetWacInfoOperations.some(active => active === url)
    ) {
        return { reason: 'InQueue' };
    }

    if (getStore.suppressedUrls.some(suppressed => suppressed === url)) {
        return { reason: 'FileTypeNotSupportedOrSuppressedAfterError' };
    }

    return { reason: 'Unknown' };
}

export interface DocLinkPreviewInfoWithReason {
    docLinkPreviewInfo?: DocLinkPreviewInfo;
    reason?: 'Expired' | 'InQueue' | 'FileTypeNotSupportedOrSuppressedAfterError' | 'Unknown';
}
